import { useRoutes } from "react-router-dom";
import getConfig from "../core/helpers/routes";
import config from "./config";

function Routes() {
  return useRoutes(getConfig(config));
}

export default Routes;
